import React from 'react'
import cl from 'classnames'

import { Props } from './types'

import styles from './styles.module.scss'

const FormErrorAlert: React.FC<Props> = ({
	errorPrefix,
	className,
	isPositionFixed,
	failedValidationFields,
	additionalFieldErrors = [],
	isCentered = false
}) => {
	if (failedValidationFields.length === 0) {
		return null
	}

	return (
		<p
			className={cl(className, styles.errors, {
				[styles.fixed]: isPositionFixed,
				[styles.isCentered]: isCentered
			})}
		>
			{`${errorPrefix} `}
			<b>{failedValidationFields.join(', ')}</b>
			{!!additionalFieldErrors.length && (
				<>
					<br />
					<b>{additionalFieldErrors.join(', ')}</b>
				</>
			)}
		</p>
	)
}

export default FormErrorAlert
